<template>
  <div class="contact-form">
    <div
      class="sp-3 light-bg p-3 bd-b"
      v-if="this.hasPrivilege('CRM_CONTATOS_EMPRESAS_VINCULAR')"
    >
      <div :class="['flex ai-c jc-sb fw-w fgap2']">
        <div>
          <h4 class="mb-0">EMPRESAS HABILITADAS</h4>
          <p class="mb-0">
            <strong>{{ companies.length }}</strong> empresas que
            <strong>{{ contactDetails.name }}</strong> está vinculado
          </p>
        </div>
        <div>
          <button
            type="button"
            @click="addDialog = !addDialog"
            class="plus-button"
          >
            <plus-icon color="#ffffff" />
          </button>
        </div>
      </div>

      <transition name="activity" mode="out-in">
        <div class="link-company-form mt-4 mb-2" v-if="addDialog">
          <div class="link-company-form__select sp-2 select-wrapper-int">
            <v-select
              v-model="selectedCustomer"
              placeholder="Selecione uma opção"
              label="name"
              :options="filteredCustomers"
              name="customer"
            >
              <template slot="option" slot-scope="option">
                {{ option.name }}
                <small>({{ option.federalID | formatCnpj }})</small>
              </template>
            </v-select>
          </div>
          <v-checkbox
            class="link-company-form__checkbox"
            name="isPortalAdministrator"
            label="Administrador Portal do Cliente"
            v-model="isPortalAdministrator"
          />
          <button
            class="activity-submit link-company-form__submit"
            @click.prevent="linkCompany"
          >
            Vincular
          </button>
        </div>
      </transition>
    </div>

    <div class="card-body pd-40 sp-3 text-center" v-if="companies.length == 0">
      <!-- <img src="@/assets/img/icon1.svg" class="wd-100 mb-4" alt=""> -->
      <h6 class="tx-md-20 tx-inverse">Nenhuma Empresa Vinculada</h6>
      <p>Vincule uma empresa clicando no botão + que está acima</p>
    </div>

    <div class="sp-3 table-overflow companies-table pd-x-10" v-else>
      <table>
        <tbody>
          <template v-for="(item, index) in filteredCompanies">
            <tr
              v-for="company in item"
              :key="index + '-' + company.id"
              :class="{ 'company-row--menu-open': actionsSubmenu === company.id }"
            >
              <td>
                <div class="company-item flex ai-c fgap2">
                  <div class="company-letter flex ai-c jc-c">
                    {{ company.name.split("")[0].toUpperCase() }}
                  </div>
                  <div class="company-info">
                    <h5
                      class="mb-0 cursor-pointer"
                      @click.prevent="
                        $router.push('/crm/clientes/' + company.id)
                      "
                    >
                      {{ company.name }}
                      <span class="tx-10">({{ company.completeName }})</span>
                    </h5>
                    <span class="tx-12 d-block" v-if="company.enabled"
                      ><span
                        class="square-8 bg-success mg-r-5 rounded-circle"
                      ></span>
                      Empresa Habilitada</span
                    >
                    <span class="tx-12 d-block" v-else
                      ><span
                        class="square-8 bg-danger mg-r-5 rounded-circle"
                      ></span>
                      Empresa Desabilitada</span
                    >
                    <span class="tx-12 d-block" v-if="company.companyAdmin"
                      ><span
                        class="square-8 bg-success mg-r-5 rounded-circle"
                      ></span>
                      Administrador do Portal do Cliente</span
                    >
                    <span class="tx-12 d-block" v-else
                      ><span
                        class="square-8 bg-danger mg-r-5 rounded-circle"
                      ></span>
                      Não é administrador do Portal do Cliente</span
                    >
                  </div>
                  <div class="company-type flex ai-c fgap2"></div>
                </div>
              </td>
              <td>
                <a
                  href="#"
                  class="tx-black"
                  @click.prevent="copyCnpj(company.federalID)"
                >
                  {{ company.federalID }}
                  <copy-icon :size="16" />
                </a>
              </td>
              <td class="actions-cell">
                <div
                  class="actions"
                  :class="{ 'actions--open': actionsSubmenu === company.id }"
                  @click.stop
                >
                  <a href="#" @click.prevent="toggleActions(company.id)">
                    <dots-icon :size="24" />
                  </a>

                  <div
                    class="actions-submenu"
                    v-if="actionsSubmenu === company.id"
                  >
                    <ul>
                      <li v-if="!company.companyAdmin">
                        <a
                          href="#"
                          @click.prevent="setPortalAdministrator(company.id)"
                          >Tornar administrador do portal</a
                        >
                      </li>
                      <li v-else>
                        <a
                          href="#"
                          @click.prevent="removePortalAdministrator(company.id)"
                          >Remover administrador do portal</a
                        >
                      </li>
                      <li class="actions-submenu__divider"></li>
                      <li>
                        <a href="#" @click.prevent="removeCompany(company.id)"
                          >Desvincular Empresa</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import config from "@/config.js";

import { CopyIcon, DotsIcon, PlusIcon } from "@/components/crm/Icons";
import moment from "moment";
import Swal from "sweetalert2";

import Axios from "axios";
import CredentialService from "@/services/CredentialService.js";
import VCheckbox from "@/components/VCheckbox.vue";

export default {
  name: "ContactCompanies",
  components: {
    CopyIcon,
    DotsIcon,
    PlusIcon,
    VCheckbox,
  },
  props: {
    contactDetails: {
      type: Object,
      default: () => {},
    },
  },
  async mounted() {
    document.addEventListener("click", this.closeActionsSubmenu);
    await this.getCompanies();
    await this.getLinkedCompanies();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeActionsSubmenu);
  },
  data() {
    return {
      search: "",
      addDialog: false,
      customers: [],
      selectedCustomer: null,
      isPortalAdministrator: false,
      companies: [],
      actionsSubmenu: null,
    };
  },
  computed: {
    filteredCustomers() {
      const customers = this.customers.filter((customer) => {
        if (!this.companies.find((company) => company.id === customer.id)) {
          return customer;
        }
      });
      return customers;
    },
    filteredCompanies() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Carregando...",
        description: "Carregando empresas vinculadas.",
      });

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      let orderedCompanies = this.companies.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      if (this.search !== "") {
        orderedCompanies = orderedCompanies.filter((com) =>
          this.searchObject(com, this.search)
        );
      }

      const grouped = orderedCompanies.reduce((rv, x) => {
        (rv[x.name.split("")[0]] = rv[x.name.split("")[0]] || []).push(x);
        return rv;
      }, {});

      this.$store.commit("setLoading", {
        show: false,
      });

      return grouped;
    },
    companyNotFind() {
      return !(Object.keys(this.filteredCompanies).length > 0);
    },
  },
  methods: {
    hasPrivilege(privilege) {
      return CredentialService.hasPrivilege(privilege);
    },
    toggleActions(companyId) {
      if (this.actionsSubmenu === companyId) {
        this.actionsSubmenu = null;
      } else {
        this.actionsSubmenu = companyId;
      }
    },
    closeActionsSubmenu() {
      this.actionsSubmenu = null;
    },
    async getLinkedCompanies() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Carregando...",
        description: "Carregando empresas vinculadas.",
      });

      try {
        const response = await Axios.get(
          `${config.env.API_DEFAULT.host}/contactData/get-companies-crm/${this.contactDetails.id}`
        );
        this.companies = response.data.data;
        this.$store.commit("setLoading", {
          show: false,
        });
      } catch (error) {
        Swal.fire({
          title: "Listar Empresas Vinculadas",
          html: `<p>Não foi possível carregar as empresas vinculadas</p> <div>${error.response.data.message}</div>`,
          type: "error",
        });
        this.$store.commit("setLoading", {
          show: false,
        });
      }
    },
    async removeCompany(companyId) {
      this.actionsSubmenu = null;

      Swal.fire({
        title: "Desvincular Empresa",
        html: "<p>Tem certeza que deseja desvincular a empresa deste contato?</p>",
        type: "info",
        showConfirmButton: true,
        confirmButtonText: "Desvincular",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
          this.$store.commit("setLoading", {
            show: true,
            label: "Carregando...",
            description: "Desvinculado o contato da empresa.",
          });

          try {
            await Axios.get(
              `${config.env.API_DEFAULT.host}/company/removeContact/${companyId}/${this.contactDetails.id}`
            );

            this.companies = this.companies.filter(
              (comp) => comp.id !== companyId
            );
          } catch (error) {
            Swal.fire({
              title: "Desvincular Empresa",
              html: "<p>Não foi possível desvincular a empresa deste contato:</p>",
              type: "error",
            });
            console.error(error);
          }

          this.$store.commit("setLoading", {
            show: false,
          });

          Swal.fire({
            title: "Desvincular Empresa",
            html: "<p>Empresa desvinculada com sucesso!</p>",
            type: "success",
          });
        }
      });
    },
    async getCompanies() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Carregando...",
        description: "Carregando empresas.",
      });

      try {
        const response = await Axios.get(
          `${config.env.API_DEFAULT.host}/company/findAllCustomers`
        );
        // const response = await Axios.get(config.env.API_DEFAULT.host + `/contactData/get-companies-crm/${this.contactDetails.id}`);
        this.customers = response.data.data;
        this.$store.commit("setLoading", { show: false });
      } catch (error) {
        this.$store.commit("setLoading", { show: false });
        Swal.fire({
          title: "Listar Empresas",
          html: `<p>Não foi possível recuperar as empresas</p> <div>${error}</div>`,
          type: "error",
        });
      }
    },
    async linkCompany() {
      if (!this.selectedCustomer) {
        Swal.fire({
          title: "Vincular Empresa",
          html: "<p>Selecione uma empresa anter de fazer o vínculo.</p>",
          type: "error",
        });
        return;
      }

      Swal.fire({
        title: "Vincular Empresa",
        html: "<p>Tem certeza que deseja vincular a empresa?</p>",
        type: "info",
        showConfirmButton: true,
        confirmButtonText: "Vincular",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      }).then(async (response) => {
        if (response.value) {
          this.$store.commit("setLoading", {
            show: true,
            label: "Carregando...",
            description: "Vinculando empresa.",
          });

          try {
            await Axios.get(
              `${config.env.API_DEFAULT.host}/company/vinculateCompanyToContact/${this.selectedCustomer.id}/${this.contactDetails.id}/${this.isPortalAdministrator}`
            );
            this.$store.commit("setLoading", { show: false });
            Swal.fire({
              title: "Vincular Empresa",
              html: "<p>A empresa foi vinculada com sucesso!</p>",
              type: "success",
            });
          } catch (error) {
            this.$store.commit("setLoading", { show: false });
            Swal.fire({
              title: "Vincular Empresa",
              html: `Não foi possível vincular a empresa: <div>${error.response.data.message}</div>`,
              type: "error",
            });
          }

          await this.getLinkedCompanies();
          this.selectedCustomer = null;
          this.isPortalAdministrator = false;
        }
      });
    },
    searchObject(object, terms) {
      let shouldReturn = false;
      // eslint-disable-next-line
      for (const key in object) {
        const value = object[key];

        if (!shouldReturn && typeof value === "string") {
          shouldReturn = value.toLowerCase().search(terms.toLowerCase()) > -1;
        } else if (!shouldReturn && typeof value === "object") {
          shouldReturn = this.searchObject(value, terms);
        } else if (!shouldReturn && typeof value === "number") {
          shouldReturn =
            value
              .toString()
              .toLowerCase()
              .search(terms.toString().toLowerCase()) > -1;
        }
      }
      return shouldReturn;
    },
    copyCnpj(value) {
      navigator.clipboard.writeText(value);
      this.$toasted.success("CNPJ Copiado para a área de transferência!", {
        position: "top-right",
        duration: 3000,
        icon: "copy",
        singleton: true,
      });
    },
    async setPortalAdministrator(companyId) {
      this.actionsSubmenu = null;

      Swal.fire({
        title: "Administrador Portal do Cliente",
        html: "<p>Tem certeza que deseja adicionar este contato como administrador de usuário do portal nesta empresa?</p>",
        type: "info",
        showConfirmButton: true,
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
          this.$store.commit("setLoading", {
            show: true,
            label: "Carregando...",
            description: "Atualizando administrador do portal.",
          });

          try {
            await Axios.get(
              `${config.env.API_DEFAULT.host}/company/vinculateCompanyToContact/${companyId}/${this.contactDetails.id}/true`
            );
            await this.getLinkedCompanies();
            Swal.fire({
              title: "Administrador Portal do Cliente",
              html: "<p>Contato adicionado como administrador de usuário do portal com sucesso!</p>",
              type: "success",
            });
          } catch (error) {
            Swal.fire({
              title: "Administrador Portal do Cliente",
              html: `<div>${error.response?.data?.message || error}</div>`,
              type: "error",
            });
          }

          this.$store.commit("setLoading", {
            show: false,
          });
        }
      });
    },
    async removePortalAdministrator(companyId) {
      this.actionsSubmenu = null;

      Swal.fire({
        title: "Administrador Portal do Cliente",
        html: "<p>Tem certeza que deseja remover este contato como administrador de usuário do portal nesta empresa?</p>",
        type: "warning",
        showConfirmButton: true,
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
          this.$store.commit("setLoading", {
            show: true,
            label: "Carregando...",
            description: "Atualizando administrador do portal.",
          });

          try {
            await Axios.get(
              `${config.env.API_DEFAULT.host}/company/vinculateCompanyToContact/${companyId}/${this.contactDetails.id}/false`
            );
            await this.getLinkedCompanies();
            Swal.fire({
              title: "Administrador Portal do Cliente",
              html: "<p>Contato removido como administrador de usuário do portal com sucesso!</p>",
              type: "success",
            });
          } catch (error) {
            Swal.fire({
              title: "Administrador Portal do Cliente",
              html: `<div>${error.response?.data?.message || error}</div>`,
              type: "error",
            });
          }

          this.$store.commit("setLoading", {
            show: false,
          });
        }
      });
    },
  },
  filters: {
    dateFormat(value) {
      return moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.link-company-form {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.link-company-form__select {
  flex: 2 1 0;
  min-width: 200px;
}

.link-company-form__checkbox {
  flex: 1 1 0;
  min-width: 260px;
}

.link-company-form__submit {
  flex: 0 0 auto;
  margin-left: auto;
}

.plus-button {
  appearance: none;
  --webkit-appearance: none;
  --moz-appearance: none;
  outline: none;
  --webkit-outline: none;
  --moz-outline: none;
  border: 0;
  background-color: #80b7e2;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  cursor: pointer;
  padding: 0;
  border-radius: 2px;
}

.plus-button:hover {
  background-color: #1768a7;
}

table {
  width: 100%;
}

.companies-table {
  overflow: visible;
}

table tr:not(:last-of-type) td {
  border-bottom: 1px solid #e2e2e2;
}

table tr td {
  padding: 20px 10px;
  color: #343a40;
}

.input-alert {
  background-color: #a80005;
  border-radius: 6px;
  color: white;
  padding: 8px 20px;
}

.input-alert a {
  font-weight: bold;
  color: white;
}

.letter-item {
  font-size: 1.1rem;
  font-weight: bold;
  color: #868ba1;
}

.letter-line {
  display: block;
  max-width: 200px;
  flex: 0 1 200px;
  width: 100%;
  height: 1px;
  background-color: #868ba1;
}

.company-item .company-letter {
  width: 36px;
  height: 36px;
  border-radius: 64px;
  background-color: #80b7e2;
  color: white;
}

.company-item h5 {
  font-weight: bold;
}

.company-item a {
  color: inherit;
}

.company-type .tag {
  display: block;
  padding: 10px 20px;
  background-color: green;
  color: white;
  border-radius: 100px;
  font-weight: 300;
}

.actions {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  height: 50px;
  cursor: pointer;
}

.actions--open {
  z-index: 21;
}

.company-row--menu-open {
  position: relative;
  z-index: 20;
}

.actions-cell {
  overflow: visible;
  position: relative;
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}

.actions-submenu {
  position: absolute;
  top: calc(100% - 10px);
  right: 0;
  z-index: 22;
  min-width: 260px;
  width: max-content;
  max-width: 300px;
  background-color: white;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.actions-submenu ul {
  margin: 0;
  padding: 6px 0;
  list-style: none;
}

.actions-submenu ul a {
  display: block;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #343a40;
  text-decoration: none;
  transition: background-color 0.2s ease-in-out 0s;
}

.actions-submenu ul a:hover {
  background-color: #f5f6f7;
}

.actions-submenu__divider {
  height: 1px;
  margin: 4px 12px;
  background-color: #e2e2e2;
}

.add-submit {
  appearance: none;
  --webkit-appearance: none;
  --moz-appearance: none;
  outline: none;
  --webkit-outline: none;
  --moz-outline: none;
  border: 0;
  background-color: #104375;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border-radius: 2px;
  color: white;
  padding: 10px 25px;
  border-radius: 10px;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out 0s;
}

.add-submit:hover {
  background-color: #1768a7;
}

.activity-submit {
  appearance: none;
  --webkit-appearance: none;
  --moz-appearance: none;
  outline: none;
  --webkit-outline: none;
  --moz-outline: none;
  border: 0;
  background-color: #104375;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border-radius: 2px;
  color: white;
  padding: 10px 25px;
  border-radius: 10px;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out 0s;
}

.activity-submit:hover {
  background-color: #1768a7;
}

.activity-enter-active,
.activity-leave-active {
  transition: all 0.5s ease-in-out 0s;
  overflow: hidden;
}

.activity-enter,
.activity-leave-to {
  max-height: 0px;
  overflow: hidden;
}

.activity-enter-to,
.activity-leave {
  transition: all 0.5s ease-in-out 0s;
  max-height: 1000px;
  overflow: hidden;
}
</style>

<style>
.select-wrapper-int {
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e2e2e2;
  padding-left: 15px;
}

.select-wrapper-int .dropdown-toggle {
  padding-left: 10px !important;
}

.select-wrapper-int input {
  height: 40px !important;
  margin-top: 0 !important;
}
</style>
